// libs
import styled from 'styled-components'
// themes
import { colors } from 'themes/index'

export const RisksHeaderWrapper = styled.div`
  background-color: ${colors.gray190};
  display: flex;
  gap: 12px;
  padding-top: 16px;
  padding-left: 8px;
  position: sticky;
  top: 0;
  z-index: 1;
  font-size: 14px;
  min-width: 100%;
  width: max-content;

  > div:not(:last-child) {
    min-width: 200px;
    max-width: 200px;
  }

  > div:last-child {
    width: 80px;
  }
`

export const HeaderItemWrapper = styled.div`
  align-items: flex-start;
  display: flex;
  justify-content: space-between;
`

export const Spacer = styled(HeaderItemWrapper)``
